module.exports = __webpack_public_path__ + "static/event-driven-7d771efd85b3c9665204dd367f97bc3a.png";